import { useTranslation } from 'react-i18next';

import { i18nNS } from '../../../../../i18n';
import PieChartIcon from '../../../../../icons/PieChartIcon';
import TileDrawerHeaderLayout from '../../../../shared/TileDrawerHeaderLayout';

const DrawerHeader = () => {
  const { t } = useTranslation([i18nNS.POLL]);

  return <TileDrawerHeaderLayout icon={PieChartIcon}>{t('pie_chart', { ns: i18nNS.POLL })}</TileDrawerHeaderLayout>;
};

export default DrawerHeader;
